export default __webpack_public_path__ + "static/media/mercy.bb20622e.svg";